import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import LoginForm from "./components/LoginForm";
import AllUsers from "./components/AllUsers";
import NotFound from "./pages/NotFound";
import { AuthProvider, useAuth } from "./context/AuthContext";
import EditUserForm from "./components/EditUserForm";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth(); // Get authentication status from context
  return isAuthenticated ? children : <Navigate to="/" replace />;
};

function App() {
  return (
    <Router basename="/admin">
      <AuthProvider>
        {" "}
        {/* Wrap your entire app with AuthProvider */}
        <Routes>
          <Route path="/" element={<LoginForm />} />
          {/* Protect the /users route */}
          <Route
            path="/users"
            element={
              <ProtectedRoute>
                <AllUsers />
              </ProtectedRoute>
            }
          />
          <Route
            path="/users/edit/:id" // This path will match URLs like /admin/users/edit/123
            element={
              <ProtectedRoute>
                <EditUserForm />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
